import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { CampaignsFiltersPanel } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/CampaignsFiltersPanel';
import { CampaignsMultiActionsPanel } from 'components/CampaignsDashboard/components/CampaignsMultiActionsPanel';
import { CampaignsTabsPanel } from 'components/CampaignsDashboard/components/CampaignsTabsPanel';

import { useSelector } from 'store/utils';

export const CampaignsControls: FC = () => {
    const hasCheckedCampaigns = useSelector((state) => state.campaignsDashboard.checkedCampaignIds.size > 0);
    return (
        <>
            <CampaignsTabsPanel />
            <VSpacing default={24} />
            {hasCheckedCampaigns ? <CampaignsMultiActionsPanel /> : <CampaignsFiltersPanel />}
        </>
    );
};
